import { apiGet, apiPatch } from './client.js';

export type TemplateItem = { name: string; order: number };

export interface DeviceConditionTemplate {
  id: string;
  tenantId: string;
  storeId: string | null;
  deviceCategory: string;
  templateType: 'conditions' | 'supplied_items';
  items: TemplateItem[];
  active: boolean;
  createdAt: string;
}

export function listDeviceConditionTemplates(params?: {
  deviceCategory?: string;
  templateType?: 'conditions' | 'supplied_items';
}) {
  return apiGet<DeviceConditionTemplate[]>('/api/v1/device-condition-templates', { params }).then(
    (res) => res.data,
  );
}

export function updateDeviceConditionTemplate(id: string, items: TemplateItem[]) {
  return apiPatch<DeviceConditionTemplate, { items: TemplateItem[] }>(
    `/api/v1/device-condition-templates/${id}`,
    { items },
  ).then((res) => res.data);
}
